"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../utils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UISelectableButton = _interopRequireDefault(require("UIComponents/button/UISelectableButton"));

var _links = require("self-service-api/core/utilities/links");

var _getProductNameText = require("../adapters/getProductNameText");

var _TrialRedirectSurvey = _interopRequireDefault(require("ui-addon-upgrades/_core/trial/TrialRedirectSurvey"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _SuccessModal = _interopRequireDefault(require("./SuccessModal"));

var _AcademyTrialModal = _interopRequireDefault(require("./AcademyTrialModal"));

var _url = require("../navigation/url");

var LANG_ROUTE = 'upgrades.activationModal.new';
var OPTIONS = {
  CREATE_NEW_USERS: 'createNewUsers',
  SPECIFIC_FEATURE: 'specificFeature',
  EXPLORE_ON_YOUR_OWN: 'exploreOnYourOwn'
};
var shuffledOptions = (0, _utils.shuffle)(Object.values(OPTIONS));

var TrialActivationSuccessSurveyModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TrialActivationSuccessSurveyModal, _React$Component);

  function TrialActivationSuccessSurveyModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TrialActivationSuccessSurveyModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TrialActivationSuccessSurveyModal).call(this, props));

    _this.handleOptionClick = function (option) {
      var _this$props = _this.props,
          upgradeData = _this$props.upgradeData,
          upgradeProduct = _this$props.upgradeData.upgradeProduct;

      switch (option) {
        case OPTIONS.CREATE_NEW_USERS:
          tracker.trackBeforeUnload('trialActivationInteraction', (0, _extends2.default)({
            action: 'clicked create new users'
          }, upgradeData));
          (0, _url.navigateTo)((0, _links.mapRedirectTargetToRoute)('user-settings'));
          break;

        case OPTIONS.SPECIFIC_FEATURE:
          tracker.track('trialActivationInteraction', (0, _extends2.default)({
            action: 'clicked try out a specific feature'
          }, upgradeData));

          _this.setState({
            showRedirectSurvey: true
          });

          break;

        case OPTIONS.EXPLORE_ON_YOUR_OWN:
          tracker.trackBeforeUnload('trialActivationInteraction', (0, _extends2.default)({
            action: 'clicked explore on my own'
          }, upgradeData));
          (0, _url.navigateTo)((0, _links.mapRedirectTargetToRoute)('other', upgradeProduct));
          break;

        default:
          break;
      }
    };

    _this.state = {
      showRedirectSurvey: false
    };
    return _this;
  }

  (0, _createClass2.default)(TrialActivationSuccessSurveyModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          onSuccess = _this$props2.onSuccess,
          _this$props2$upgradeD = _this$props2.upgradeData,
          app = _this$props2$upgradeD.app,
          upgradeProduct = _this$props2$upgradeD.upgradeProduct,
          upgradeData = _this$props2.upgradeData;
      var showRedirectSurvey = this.state.showRedirectSurvey;
      var productName = (0, _getProductNameText.getProductNameText)(upgradeProduct); // This is temporary until we start to unwind these post-activation flows

      if (app === 'learning-center') {
        return _react.default.createElement(_AcademyTrialModal.default, {
          onSuccess: onSuccess
        });
      }

      if (showRedirectSurvey) {
        return _react.default.createElement(_SuccessModal.default, {
          header: _react.default.createElement(_FormattedMessage.default, {
            message: LANG_ROUTE + ".redirectModal.header"
          }),
          footer: _react.default.createElement(_TrialRedirectSurvey.default, {
            upgradeData: upgradeData
          })
        });
      }

      return _react.default.createElement(_SuccessModal.default, {
        header: _react.default.createElement(_FormattedMessage.default, {
          message: LANG_ROUTE + ".successModal.header"
        }),
        footer: _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
          message: LANG_ROUTE + ".successModal.subHeader",
          options: {
            productName: productName
          }
        }), _react.default.createElement("div", {
          className: "text-left m-top-6",
          style: {
            width: '100%'
          }
        }, _react.default.createElement("h5", null, _react.default.createElement(_FormattedMessage.default, {
          message: LANG_ROUTE + ".successModal.firstAction"
        })), _react.default.createElement(_UIList.default, null, shuffledOptions.map(function (option) {
          return _react.default.createElement(_UISelectableButton.default, {
            className: "m-bottom-2 display-inline-block text-left",
            textLabel: _react.default.createElement(_FormattedMessage.default, {
              message: LANG_ROUTE + ".successModal.actions." + option
            }),
            block: true,
            name: "other",
            truncatable: false,
            onClick: function onClick() {
              return _this2.handleOptionClick(option);
            },
            key: option
          });
        }))))
      });
    }
  }]);
  return TrialActivationSuccessSurveyModal;
}(_react.default.Component);

var _default = TrialActivationSuccessSurveyModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/TrialActivationSuccessSurveyModal.js
// module id = 741
// module chunks = 5 6